import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 350,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Code",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "--",
	},
	
	...createdAtmodifiedAtActions
];
